import BackToHomePage from "./BackToHomePage";
import Home from "./Home";
import Snow from './Snow';

class Projects extends Home{

    constructor(props){
        super(props);
    }

    render(){
        return(
            <main>

                <body className={this.state.scale}>

                    <Snow></Snow>

                    <div className="my-12  text-center text-white">
                        <p className="text-3xl md:text-4xl font-black"> Projects : </p>
                    </div>
                    <ul 

                    className="text-1xl md:text-3xl text-center my-12">

                           <li className="text-white my-7">
                          <a 
                            href="https://github.com/milanm98?tab=repositories"
                               target="_blank"> 
                            GitHub
                            </a>
                        </li>

                        

                           <li className="text-white my-10 font-black mx-10">
                             <a 
                            href="https://github.com/milanm98?tab=repositories"
                            target="_blank"> 
                            You can also check my progress and work on this links : 
                            </a>
                        </li>

                        <li
                        className="text-white my-10">
                            <a 
                            href="https://codepen.io/milanm98"
                            target="_blank"> 
                            CodePen
                            </a>
                        </li>

                        <li
                        className="text-white my-10">
                            <a 
                            href="https://www.hackerrank.com/marjanovm"
                            target="_blank"> 
                            HackerRank
                            </a>
                        </li>

                        <li
                        className="text-white my-10">
                            <a 
                            href="https://www.freecodecamp.org/mari98"
                            target="_blank"> 
                            FreeCodeCamp
                            </a>
                        </li>

                       

                    </ul>

                    <BackToHomePage>
                    </BackToHomePage>


                </body>
            </main>
        )   
    }

}

export default Projects;